// extracted by mini-css-extract-plugin
export default {"accordionListBlock":"AccordionListBlock_accordionListBlock__Eib1H"};